import { AiFillInstagram } from 'react-icons/ai';
import { FaFacebookF, FaTwitter, FaLinkedinIn } from 'react-icons/fa';  

import Avatar01 from '../../../assets/img/teamAvatar/01.png';
import Avatar02 from '../../../assets/img/teamAvatar/02.png';
import Avatar03 from '../../../assets/img/teamAvatar/03.png';
import Avatar04 from '../../../assets/img/teamAvatar/04.png';

import './styles.css';

const Team = () =>{
  return(
    <div className="division3">
      <h1 className="title-responsive text-center">
        our creative team
      </h1>
      <div className="container division2 d-flex flex-wrap justify-content-center justify-content-md-between">
      <div className="col-10 col-md-6 col-lg-3 px-2 mt-4 mt-lg-0">
          <div className="w-100">
            <div className="top-line bg-blue" />
            <div className="bg-light py-5 d-flex flex-column align-items-center">
              <div className="col-10 d-flex flex-column align-items-center">
                <div className="col-11">
                  <img
                  src={Avatar01}
                  alt="..."
                  className="w-100 team-avatar"
                  />
                </div>
                <h3 className="mt-3 font-weight-bolder">
                  Julian Alvez
                </h3>
                <p className="paragraph">
                  Founder {'&'} Ceo
                </p>
                <div className="px-5 d-flex mt-3">
                  <div className="hexagon bg-facebook mx-1 d-flex align-items-center justify-content-center text-white pointer">
                    <FaFacebookF size="50%" />
                  </div>
                  <div className="hexagon bg-twitter mx-1 d-flex align-items-center justify-content-center text-white pointer">
                    <FaTwitter size="50%" />
                  </div>
                  <div className="hexagon bg-linkedin mx-1 d-flex align-items-center justify-content-center text-white pointer">
                    <FaLinkedinIn size="50%" />
                  </div>
                  <div className="hexagon bg-instagram mx-1 d-flex align-items-center justify-content-center text-white pointer">
                    <AiFillInstagram size="60%" />
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
        <div className="col-10 col-md-6 col-lg-3 px-2 mt-4 mt-lg-0">
          <div className="w-100">
            <div className="top-line bg-green" />
            <div className="bg-light py-5 d-flex flex-column align-items-center">
              <div className="col-10 d-flex flex-column align-items-center">
                <div className="col-11">
                  <img
                  src={Avatar02}
                  alt="..."
                  className="w-100 team-avatar"
                  />
                </div>
                <h3 className="mt-3 font-weight-bolder">
                  William Dent
                </h3>
                <p className="paragraph">
                  Founder {'&'} Ceo
                </p>
                <div className="px-5 d-flex mt-3">
                  <div className="hexagon bg-facebook mx-1 d-flex align-items-center justify-content-center text-white pointer">
                    <FaFacebookF size="50%" />
                  </div>
                  <div className="hexagon bg-twitter mx-1 d-flex align-items-center justify-content-center text-white pointer">
                    <FaTwitter size="50%" />
                  </div>
                  <div className="hexagon bg-linkedin mx-1 d-flex align-items-center justify-content-center text-white pointer">
                    <FaLinkedinIn size="50%" />
                  </div>
                  <div className="hexagon bg-instagram mx-1 d-flex align-items-center justify-content-center text-white pointer">
                    <AiFillInstagram size="60%" />
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
        <div className="col-10 col-md-6 col-lg-3 px-2 mt-4 mt-lg-0">
          <div className="w-100">
            <div className="top-line bg-purple" />
            <div className="bg-light py-5 d-flex flex-column align-items-center">
              <div className="col-10 d-flex flex-column align-items-center">
                <div className="col-11">
                  <img
                  src={Avatar03}
                  alt="..."
                  className="w-100 team-avatar"
                  />
                </div>
                <h3 className="mt-3 font-weight-bolder">
                  Josue  Smith
                </h3>
                <p className="paragraph">
                  Founder {'&'} Ceo
                </p>
                <div className="px-5 d-flex mt-3">
                  <div className="hexagon bg-facebook mx-1 d-flex align-items-center justify-content-center text-white pointer">
                    <FaFacebookF size="50%" />
                  </div>
                  <div className="hexagon bg-twitter mx-1 d-flex align-items-center justify-content-center text-white pointer">
                    <FaTwitter size="50%" />
                  </div>
                  <div className="hexagon bg-linkedin mx-1 d-flex align-items-center justify-content-center text-white pointer">
                    <FaLinkedinIn size="50%" />
                  </div>
                  <div className="hexagon bg-instagram mx-1 d-flex align-items-center justify-content-center text-white pointer">
                    <AiFillInstagram size="60%" />
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
        <div className="col-10 col-md-6 col-lg-3 px-2 mt-4 mt-lg-0">
          <div className="w-100">
            <div className="top-line bg-yellow" />
            <div className="bg-light py-5 d-flex flex-column align-items-center">
              <div className="col-10 d-flex flex-column align-items-center">
                <div className="col-11">
                  <img
                  src={Avatar04}
                  alt="..."
                  className="w-100 team-avatar"
                  />
                </div>
                <h3 className="mt-3 font-weight-bolder">
                  Kenneth Marr
                </h3>
                <p className="paragraph">
                  Founder {'&'} Ceo
                </p>
                <div className="px-5 d-flex mt-3">
                  <div className="hexagon bg-facebook mx-1 d-flex align-items-center justify-content-center text-white pointer">
                    <FaFacebookF size="50%" />
                  </div>
                  <div className="hexagon bg-twitter mx-1 d-flex align-items-center justify-content-center text-white pointer">
                    <FaTwitter size="50%" />
                  </div>
                  <div className="hexagon bg-linkedin mx-1 d-flex align-items-center justify-content-center text-white pointer">
                    <FaLinkedinIn size="50%" />
                  </div>
                  <div className="hexagon bg-instagram mx-1 d-flex align-items-center justify-content-center text-white pointer">
                    <AiFillInstagram size="60%" />
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};
export default Team;